'use client';

import { useMemo, useState } from "react"

import { useIsMobile } from "@/hooks/isMobile";

import { AreaChart, ChartDataPoint, ChartSeries } from "@/components/charts/area-chart"
import { useQueryResults } from "@/hooks/useQueryResults";
import { useDarkMode } from "@/hooks/useDarkMode";
import { DatasetAreaChart, DatasetSource } from "./charts/dataset-area-chart";
import { Percent, Sigma } from "lucide-react";

export function SkyCompetitiveOverviewEcharts() {
    const { results } = useQueryResults({id: 6680585})
    const [showPct, setShowPct] = useState(false)
    const isDark = useDarkMode()
    const isMobile = useIsMobile()

    const _switch = () => setShowPct(!showPct)

    const formatter = new Intl.NumberFormat("en", {notation: "compact"})
    const tooltipFormatter = new Intl.NumberFormat("en", {maximumFractionDigits: 0})
    const percentFormatter = new Intl.NumberFormat("en", {style: 'percent', maximumFractionDigits: 2})

    const formattedData_Dataset: DatasetSource = useMemo(() => {
        if (!results || results.length === 0 || !results[0]) return {dimensions: [], source: []};
        let keys = Object.keys(results[0]).filter((k: string) => !['minute', 'hour', 'day', 'month', 'date', 'block_date', 'date_unix'].includes(k))

        return {
            dimensions: ['date'].concat(keys),
            source: results.map(r => {
               return [r.date.toDate(), ...keys.map(k => r[k])] 
            })
        }
    }, [results])

    const pctData_Dataset = useMemo(() => {
        return {
            dimensions: formattedData_Dataset.dimensions,
            source: formattedData_Dataset.source.map(s => {
                const sum = s.slice(1).reduce((a, v) => (a as number) + (v as number), 0) as number
                return [
                    s[0],
                    ...s.slice(1).map(v => (v as number) / sum)
                ]
            })
        }

    }, [formattedData_Dataset])

    return (
        <div className="w-full h-[40vh]">
            <DatasetAreaChart
                dataset={showPct?pctData_Dataset:formattedData_Dataset}
                title="Market Overview"
                description="Major mainnet venues for stable coin yield"
                yAxisFormatter={(n) => showPct?percentFormatter.format(n):formatter.format(n)}
                tooltip={{
                    seriesValueFormatter: (value) => showPct?percentFormatter.format(value):`$${tooltipFormatter.format(value)}`
                }}
                showTotal
                legendActions={[
                    {
                        name: `Switch to ${showPct?'nominal':'percent'} view`,
                        action: _switch,
                        icon: showPct?Sigma:Percent
                    }
                ]}
            />
        </div>
    )
}
